module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M28.813 16.053l2.877-2.877a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-2.877 2.877-2.867-2.867a1 1 0 0 0-1.414 0l-1.414 1.414a1 1 0 0 0 0 1.414l2.867 2.867-2.867 2.867a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l2.867-2.867 2.877 2.877a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-2.877-2.877zM16.077.272l-8.079 7.74H2c-1.106 0-1.999.968-1.999 2.051v11.9c0 1.084.894 2.041 1.999 2.041h5.998l8.121 7.806s1.875 1.124 1.875-2.129V2.216c0-3.287-1.917-1.943-1.917-1.943z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/speaker-3.js
// module id = 1429
// module chunks = 14